import React from 'react';
import ErrorComponent from './ErrorComponent';

const PageNotAuthorized = props => {
  return <ErrorComponent props={props} errorType="403"></ErrorComponent>;
};

export default PageNotAuthorized;
